import { animate, state, style, transition, trigger } from '@angular/animations';
import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, ElementRef, OnInit } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { HierarchyObject, PageBase } from 't4core';
import { T4Image } from '../../../../../dist/t4core';
import { ImageType } from '../../../../../projects/t4core/src/public-api';
import { ContextDialog } from '../../../TurboOrder/dialogs/ContextDialog/ContextDialog';

/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
  imageurl: string;
}

@Component({
  styleUrls: ['./ContextTree.css'],
  selector: 'contexttree',
  templateUrl: './ContextTree.component.html',
  animations: [
    trigger('formState', [
      state('visible', style({
        opacity: 1.0,
        display: 'block'
      })),
      state('hidden', style({
        opacity: 0,
        display: 'none'
      })),
      transition('hidden => visible', [animate('50ms 50ms ease-in')]),
      transition('visible => hidden', [animate('50ms ease-out')])
    ])]
})

export class ContextTreeComponent extends PageBase implements OnInit {
  private _transformer = (node: HierarchyObject, level: number) => {
    return {
      expandable: !!node.Children && node.Children.length > 0,
      name: node.Name,
      level: level,
      imageurl: node.ImageUrl,
      id: node.ID,
      groupId: node.GroupId
    };
  };

  treeControl = new FlatTreeControl<ExampleFlatNode>(
    node => node.level,
    node => node.expandable,
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    node => node.level,
    node => node.expandable,
    node => node.Children,
  );

  dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

  constructor(el: ElementRef) {
    super(el, "ContextTree");
  }
  async ngOnInit() {
    await this.LoadTree();


    console.log(this.dataSource);
    console.log(this.dataSource.data);
  }

  public subForms = {
    loading: "hidden",
  };

  public hasChild = (_: number, node: ExampleFlatNode) => node.expandable;

  private async LoadTree() {
    this.subForms.loading = 'visible';
    this.dataSource.data = await this.Api.get<HierarchyObject[]>("UtilService/GetContextTree");
    this.subForms.loading = 'hidden';
  }


  async createNewGroup(node) {

    if (node.id) {
      const newName = window.prompt("Enter a name:");

      if (newName) {
        console.log("New name:", newName);
        await this.Api.post("TurboOrder/CreateGroup", null, { name: newName, parentId: node.id});
      } else {
        console.log("No name provided.");
      }
    } else {
      console.log("Group not found.");
    }
  }


  async uploadLogo(node) {

    var ret = await this.UI.openDialog<T4Image>("T4.Common.UploadImageDialog", { data: { imageType: ImageType.LocationGroup, entityId: node.groupId } });
    if (ret) {
      node.imageurl = ret.Uri;
    }
  }

  async uploadPin(node) {
    var ret = await this.UI.openDialog<T4Image>("T4.Common.UploadImageDialog", { data: { imageType: ImageType.LocationGroupPin, entityId: node.groupId } });
    if (ret) {
      this.UI.snackBar("Pin has been uploaded");
    }
  }

  public async contextDialog(node) {
    console.log(node.id);
    console.log(node.name);
    ContextDialog.open(this.Dialog, node.id, node.name);
  }
}
